module.exports = __webpack_public_path__ + "static/img/shuzhiCompany.16b85344.png";